import { render, staticRenderFns } from "./PatientChart.vue?vue&type=template&id=f467f7da"
import script from "./PatientChart.vue?vue&type=script&lang=js"
export * from "./PatientChart.vue?vue&type=script&lang=js"
import style0 from "./PatientChart.vue?vue&type=style&index=0&id=f467f7da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports